import React from 'react';

const PersonSadSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 21c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-19C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 11.5c-2 0-3.8 1-4.6 3h-.9v1h2v-.9c.7-1.2 2-2.1 3.5-2.1s2.8.8 3.5 2.1v.9h2v-1h-.9c-.8-2-2.6-3-4.6-3z"
        />
        <g fillRule="evenodd" clipRule="evenodd" fill="#231F20">
            <path d="M8 8h1v2H8zM15 8h1v2h-1z" />
        </g>
    </svg>
);

PersonSadSvg.displayName = 'PersonSadSvg';
export default PersonSadSvg;
